import * as angular from "angular";

angular
  .module('bringoz.admin.self-pickups')
  .constant('SelfPickups_PN', {
    database: 'selfpickups',
    isBranchEntity: false
  });
